import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { flexCenter, flexCenterColumn } from '@seedlang/style_mixins';
import { last } from 'lodash';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  width: 100%;
  justify-content: center;
`;

const Button = styled.div`
  ${flexCenterColumn()}
  background: #FFF;
  border: 1px solid gray;
  padding: 0;
  cursor: pointer;
  border-radius: 5px;
  margin: 0 2px;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s ease;
  border-color: ${props => props.active ? 'var(--legend-color)' : 'gray'};
  &:hover {
    opacity: 0.75;
  }
`;

const Top = styled.div`
  ${flexCenter()}
  padding: 0 10px;
  position: relative;
  z-index: 1;
`;

const Key = styled.div`
  ${flexCenter()}
  background-color: ${props => props.backgroundColor};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px 0 0;
  transition: transform 0.3s ease;
  position: relative;
  transform: ${props => props.active ? 'scale(100)' : 'scale(1)'};
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: white;
    transform: ${props => props.active ? 'scale(calc(1 / 100))' : 'scale(0)'};
    transition: transform 0.3s ease;
  }
`;

const Label = styled.div`
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
  color: ${props => props.active ? 'white' : 'inherit'};
`;

const Count = styled.div`
  border-top: 1px solid gray;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 100%;
  font-size: 28px;
  padding: 10px;
  height: 50px;
`;

@observer
class Legend extends React.Component {

  count(resource) {
    let count;
    if (this.props.chartType === 'cumulative') {
      count = last(resource.data)?.y ?? 0;
    } else {
      count = resource.data.map(item => item.y).reduce((a, b) => a + b, 0);
    }
    return Number(parseFloat(count).toFixed(2)).toLocaleString('en');
  }

  render() {
    return (
      <Wrapper>
        {
          this.props.data && this.props.data.map(item => {
            const active = this.props.selectedIds?.includes(item.id) ?? false;
            return (
              <Button
                key={item.id}
                onClick={() => this.props.onToggle?.(item.label || item.id)}
                active={active}
                style={{ '--legend-color': this.props.colors[item.colorIndex] }}
              >
                <Top>
                  <Key
                    backgroundColor={this.props.colors[item.colorIndex]}
                    active={active}
                  />
                  <Label active={active}>
                    {item.label || item.id}
                  </Label>
                </Top>
                {
                  !this.props.hideCounts &&
                    <Count>
                      {!this.props.loadingData && this.count(item)}
                    </Count>
                }
              </Button>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Legend);
